<script setup lang="ts">
import type { StoreFitter } from './StoreFinderStore.vue'

const props = defineProps<{
    fitter: StoreFitter
}>()

function validateData(data: unknown): data is string {
    return typeof data === 'string' && data.trim() !== ''
}

function fitterContact(): string | undefined {
    if (validateData(props.fitter?.url)) {
        return props.fitter.url
    }
    if (validateData(props.fitter?.email)) {
        return `mailto:${props.fitter.email}`
    }
}
</script>

<template>
    <div class="flex flex-col">
        <MiscImage
            v-if="validateData(fitter?.image?.url)"
            :src="fitter.image!.url!"
            :alt="fitter?.image?.alt"
            width="450"
            style="max-width: 100%;"
        />
        <div class="bg-base-200 flex flex-col gap-6 px-3 py-4">
            <div
                v-if="validateData(fitter?.name)"
                class="text-2xl font-semibold uppercase"
            >
                {{ fitter.name }}
            </div>
            <div class="flex flex-col">
                <div class="text-lg font-semibold mb-4">
                    {{ $t('fitting.fitterHeadline') }}
                </div>
                <div
                    v-if="validateData(fitter?.phone)"
                    class="text-sm"
                >
                    {{ $t('fitting.fitterPhone') }} {{ fitter.phone }}
                </div>
                <div
                    v-if="validateData(fitter?.email)"
                    class="text-sm"
                >
                    {{ $t('fitting.fitterEmail') }} {{ fitter.email }}
                </div>
            </div>
            <a
                :href="fitterContact()"
                class="btn btn-accent"
            >{{ $t('fitting.bookFitting') }} <MiscIcon
                name="arrow-right"
                size="sm"
            /></a>
        </div>
    </div>
</template>
